<template>
  <div style="margin-top:5px;margin-bottom: 55px;">
    <!-- <b-card no-body> -->
    <!-- <b-tabs small content-class="mt-3" fill pills>
        <b-tab no-body title="Notes" active> -->

    <b-form-textarea
      id="textarea-no-resize"
      placeholder="Enter your notes here"
      rows="7"
      no-resize
      v-model="editorText"
    ></b-form-textarea>
    <br />
    <div class="d-flex justify-content-center" style="margin-top:-8px;">
      <b-button
        @click="saveNotes()"
        size="sm"
        variant="outline-primary"
        style="margin:0 0.6rem"
        >Save</b-button
      >
      <b-button
        @click="clearNotes()"
        size="sm"
        variant="outline-danger"
        style="margin:0 0.6rem"
        >Close</b-button
      >
    </div>
    <!-- </b-tab> -->
    <!-- </b-card> -->
  </div>
</template>

<script>
import store from "../../store";
import { mapGetters } from "vuex";

export default {
  name: "AddNotes",
  data() {
    return {
      editorText: "",
    };
  },
  created() {},
  methods: {
    saveNotes() {
      console.log("SAVE NOTES CLICKED", this.editorText);
      var passData = {};
      passData.action = "CREATE_NOTES";
      passData.editorText = this.editorText;
      passData.callerId = this.callerId;
      passData.conversationId = this.freshchat_conversation_id;
      passData.channelId = this.freshchat_channel_id;
      passData.assignedAgentId = this.freshchat_agent_id;
      store.dispatch("call/updateNotesEditor", false);
      parent.postMessage(passData, "*");
      this.editorText = "";
    },
    clearNotes() {
      console.log("CLEAR NOTES ");
      store.dispatch("call/updateNotesEditor", false);
      this.editorText = "";
    },
  },
  computed: {
    ...mapGetters([
      "call_state",
      "caller_name",
      "queue_name",
      "caller_number",
      "mute_status",
      "hold_status",
      "start_time",
      "end_time",
      "displayHours",
      "displayMinutes",
      "displaySeconds",
      "caller_id",
      "freshchat_conversation_id",
      "freshchat_channel_id",
      "freshchat_agent_id",
    ]),
  },
};
</script>
